const getVariant = () => {
  // Extract 'operator_theme' from the URL query parameters
  const urlParams = new URLSearchParams(window.location.search);
  const operatorThemeQueryParam = urlParams.get('operator_theme');

  // Retrieve and parse stored PPG data from sessionStorage
  const storedPPG = sessionStorage.getItem('PPG');
  const sessionData = storedPPG ? JSON.parse(storedPPG) : null;
  // Determine the operator theme, giving priority to session data
  const operatorTheme = operatorThemeQueryParam || sessionData?.operator_theme;
  // Map and return operator themes to paths ('wol' for '1xbet/mega_wheel', 'mw' otherwise)
  return operatorTheme === '1xbet/mega_wheel' ? 'wol' : 'mw';
};
export default getVariant;
